<template>
    <div
        class="flex w-full space-x-2 items-start"
        data-cy="card-detail-row"
    >
        <component
            :is="cardDetailTypes[item.type]"
            v-for="(item, index) in item.details"
            :key="index"
            :item="item"
            class="basis-full"
            @click="emit('click', $event)"
        />
    </div>
</template>

<script setup>
    import cardDetailTypes from '@/constants/cardDetailTypes'

    const props = defineProps({
        item: Object,
    })

    const emit = defineEmits(['click'])
</script>
